import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#083a94', // Azul profesional
    },
    secondary: {
      main: '#38BDF8', // Celeste vibrante
    },
    background: {
      default: '#F4F4F5', // Gris claro
    },
    text: {
      primary: '#1F2937', // Gris oscuro
    },
  },
  typography: {
    fontFamily: 'Roboto, sans-serif',
  },
});

export default theme;
